import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    if (window.location.pathname === "/viaje") {
      return this.props.children;
    }

    return (
      <div>
        { /*<NavMenu />*/}
        <Container>
          {this.props.children}
        </Container>
      </div>
    );
  }
}
